import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

export default function FAQ() {
  return (
    <section className="bg-white py-16">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="text-xs font-bold uppercase tracking-widest text-orange-600">Have questions?</div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#0b3d5b] mt-2">Frequently Asked Questions</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-slate-200 rounded-xl px-5 bg-slate-50/40 data-[state=open]:bg-white data-[state=open]:shadow-md transition-all">
              <AccordionTrigger className="text-left font-semibold text-[#0b3d5b] hover:text-orange-600 py-4">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-4 text-[15px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
